import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'nl2br',
    standalone: true
})
export class Nl2BrPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);


    transform(value: string | SafeHtml): SafeHtml {
        if (!value) {
            return value;
        }
        
        // If it's already SafeHtml, convert to string
        const stringValue = typeof value === 'string' ? value : value.toString();
        
        // Replace newlines with <br> tags
        const result = stringValue.replace(/\n/g, '<br>');
        
        return this.sanitizer.sanitize(1, result) || '';
    }
}
